export default "__VITE_PUBLIC_ASSET__5ebe22fd__"